"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGN_POPUP_HEIGHT = exports.SIGN_POPUP_WIDTH = void 0;
exports.SIGN_POPUP_WIDTH = 390;
exports.SIGN_POPUP_HEIGHT = 590;